<div *nzModalTitle>
    <span>{{ data.nzTitle }}</span>
</div>

<div class="p-4">
    <div class="mb-4">
        <input
            nz-input
            placeholder="Buscar por módulo o permiso..."
            [(ngModel)]="searchText"
            (ngModelChange)="onSearch()"
            style="width: 100%"
        />
    </div>

    @if (isLoading) {
        <div class="text-center py-8 text-gray-500">Cargando permisos...</div>
    } @else if (filteredPermissions.length === 0) {
        <nz-empty nzNotFoundContent="No hay permisos disponibles para añadir"></nz-empty>
    } @else {
        <nz-table
            #permTable
            [nzData]="filteredPermissions"
            nzBordered
            [nzPageSize]="10"
            nzSize="small"
        >
            <thead>
                <tr>
                    <th>Módulo</th>
                    <th>Permiso</th>
                    <th class="text-center" style="width: 100px">Acción</th>
                </tr>
            </thead>
            <tbody>
                @for (p of permTable.data; track p.id) {
                    <tr>
                        <td>{{ p.mainkey }}</td>
                        <td>{{ p.key }}</td>
                        <td class="text-center">
                            <button class="button primary-button" type="button" (click)="selectPermission(p)">
                                Añadir
                            </button>
                        </td>
                    </tr>
                }
            </tbody>
        </nz-table>
    }
</div>

<div *nzModalFooter>
    <button class="button secondary-button" type="button" (click)="handleCancel()">Cerrar</button>
</div>
